function getImageBrightness(img, x, y) {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    const imgRect = img.getBoundingClientRect();
    const relX = ((x - imgRect.left) / imgRect.width) * img.naturalWidth;
    const relY = ((y - imgRect.top) / imgRect.height) * img.naturalHeight;
    
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);
    
    const pixel = ctx.getImageData(relX, relY, 1, 1).data;
    const brightness = (pixel[0] * 299 + pixel[1] * 587 + pixel[2] * 114) / 1000;
    return brightness;
  } catch (e) {
    return null;
  }
}

function isPointInsideElement(x, y, element) {
  const rect = element.getBoundingClientRect();
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

function checkBackground() {
  const header = document.querySelector('.header');
  if (!header) return;

  if (window.location.pathname.includes('/apps/page/wishlist')) {
    header.classList.remove('header--dark-bg');
    return;
  }
  
  const rect = header.getBoundingClientRect();
  const x = window.innerWidth / 2;
  const y = rect.bottom + 1;
  
  let element = document.elementFromPoint(x, y);
  if (!element) {
    header.classList.remove('header--dark-bg');
    return;
  }
  
  // Si es VIDEO, logo blanco
  if (element.tagName === 'VIDEO') {
    header.classList.add('header--dark-bg');
    return;
  }
  
  // Si es IMAGEN directamente
  if (element.tagName === 'IMG') {
    const brightness = getImageBrightness(element, x, y);
    
    if (brightness !== null) {
      const isDark = brightness < 128;
      header.classList.toggle('header--dark-bg', isDark);
    } else {
      header.classList.add('header--dark-bg');
    }
    return;
  }
  
  // Buscar imagen en los padres (para collages)
  let current = element;
  for (let i = 0; i < 6; i++) {
    if (!current) break;
    
    const img = current.querySelector('img');
    // Verificar que la imagen esté realmente en la posición del punto
    if (img && isPointInsideElement(x, y, img)) {
      const brightness = getImageBrightness(img, x, y);
      
      if (brightness !== null) {
        const isDark = brightness < 128;
        header.classList.toggle('header--dark-bg', isDark);
      } else {
        header.classList.add('header--dark-bg');
      }
      return;
    }
    
    current = current.parentElement;
  }
  
  // Si no es imagen/video, buscar color de fondo
  current = element;
  let isDark = false;
  
  for (let i = 0; i < 15; i++) {
    if (!current || current === document.body) break;
    
    const bg = window.getComputedStyle(current).backgroundColor;
    
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
      const rgb = bg.match(/\d+/g);
      if (rgb) {
        const brightness = (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000;
        isDark = brightness < 128;
        break;
      }
    }
    
    current = current.parentElement;
  }
  
  header.classList.toggle('header--dark-bg', isDark);
}

document.addEventListener('DOMContentLoaded', checkBackground);
window.addEventListener('load', checkBackground);
window.addEventListener('scroll', checkBackground);
window.addEventListener('resize', checkBackground);
setInterval(checkBackground, 200);
